


































































import { Component, PropSync, Vue } from 'vue-property-decorator'
import { formatarDataHora, formatarMoeda } from '@/shareds/formatadores'
import { MovimentacaoDeCaixa } from '@/models'
import type { FechamentoDeCaixa  } from '@/models'
import moment from 'moment'
import BotaoDeDownloadDeAnexoDeFechamento from '@/components/venda/BotaoDeDownloadDeAnexoDeFechamento.vue'
import { SaveFechamentoDeCaixaUseCase } from '@/usecases'

@Component({
	components:{
		BotaoDeDownloadDeAnexoDeFechamento,
	},
})
export default class TabelaDeMovimentacoes extends Vue{
	@PropSync('value', { type: Object}) fechamento!: FechamentoDeCaixa

	saveFechamentoDeCaixaUseCase = new SaveFechamentoDeCaixaUseCase()
	
	formatarDataHora = formatarDataHora
	formatarMoeda = formatarMoeda
	baixandoAnexos = false
	movimentacao: MovimentacaoDeCaixa[] = []

	get movimentacoesOrdenadas() {
		return [...this.fechamento.turnoDeVenda.movimentacoes].sort(
			(movimentacaoA, movimentacaoB) => moment(movimentacaoA.dataHoraMovimentacao).diff(movimentacaoB.dataHoraMovimentacao),
		)
	}

	get totalEmMovimentacoes() {
		const totalMovimentado = this.fechamento.turnoDeVenda.movimentacoes
			.filter(movimentacao => movimentacao.tipoMovimentacao !== 'Abertura')
			.reduce(
				(total, movimentacao) => total + (movimentacao.tipoMovimentacao === 'Sangria' ? -movimentacao.valor : movimentacao.valor), 0,
			)
		return totalMovimentado !== 0 ? totalMovimentado * -1 : 0
	}
}
